import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

export function ConfirmDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "info",
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 0 },
      }}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, fontSize: "1.3rem", fontWeight: 700, pt: 3 }}>
        {title}
      </DialogTitle>
      <DialogContent
        sx={{ py: 3, color: "#555", fontSize: "0.95rem", lineHeight: 1.6 }}
      >
        {message}
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 2, justifyContent: "flex-end" }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            borderColor: "#999",
            color: "#333",
            borderRadius: 0,
            border: "1px solid #999",
            textTransform: "uppercase",
            fontSize: "0.75rem",
            fontWeight: 600,
            padding: "6px 14px",
            "&:hover": {
              borderColor: "#333",
              backgroundColor: "#fff",
            },
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: variant === "danger" ? "#dc3545" : "#007bff",
            color: "#fff",
            borderRadius: 0,
            // textTransform: 'uppercase',
            fontSize: "0.85rem",
            fontWeight: 600,
            padding: "8px 16px",
            "&:hover": {
              backgroundColor: variant === "danger" ? "#c82333" : "#0056b3",
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
